document.addEventListener("DOMContentLoaded", function () {

  // redirect to pdp when someone logins from reconnect subscription pdp page
  const loginButton = document.getElementById("login_button");
  if (loginButton) {
    loginButton.addEventListener("click", function () {
      localStorage.setItem(
        "redirect_after_login",
        "/products/ausim-reconnect-subscription"
      );
    });
  }
  // redirect to page after login
  const page_login_redirect = document.getElementById("page_login_redirect");
  if (page_login_redirect) {
    page_login_redirect.addEventListener("click", function () {
      localStorage.setItem(
        "redirect_page_login",
        "/pages/child-profile"
      );
    });
  }

  if (document.body.classList.contains('template-index')) {
    // Prioritize redirect_after_login if both exist
    const redirectURL = localStorage.getItem('redirect_after_login');
    const pageRedirectURL = localStorage.getItem('redirect_page_login');

    if (redirectURL) {
      localStorage.removeItem('redirect_after_login');
      window.location.href = redirectURL;
    } else if (pageRedirectURL) {
      localStorage.removeItem('redirect_page_login');
      window.location.href = pageRedirectURL;
    }
  }
  
  // Form js 
  initChildProfileForm();

  // PDP form render js 
  const container = document.querySelector("#child-creation-data");
  const render_container = document.querySelector("#reconnect-container-main");
  if (render_container) return;
  if (!container) return;

  fetch('/pages/child-profile')
    .then(response => response.text())
    .then(html => {
      // Parse the fetched HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const formSection = doc.querySelector('#reconnect-container-main');
      if (formSection) {
        container.innerHTML = ''; // Clear if needed
        container.appendChild(formSection);
        initChildProfileForm();
      } else {
        console.warn('Form section not found on fetched page');
      }
    })
    .catch(err => {
      console.error('Failed to load form:', err);
    });
});

function initChildProfileForm() {
  const customerId =  window.customerId;

  // Numbering to input fields
  const fields = document.querySelectorAll('.field_number');
  if (fields.length) {
    fields.forEach((el, i) => {
      el.textContent = `${i + 1}.`;
    });
  }

  let current_step = 1;
  const total_steps = parseInt(document.querySelector(".reconnect-pagination")?.getAttribute('total_step'));
  const bar_base_value = 100 / total_steps;

  const backBtn = document.querySelector(".reconnect_pagination_back");
  const nextBtn = document.querySelector(".reconnect_pagination_next");

  backBtn && backBtn.addEventListener("click", function (e) {
    if (current_step > 1) {
      current_step -= 1;
      document.querySelectorAll('.reconnect_steps_block').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelector(`.reconnect_steps_block[steps_block="${current_step}"]`).style.display = 'block';
      document.querySelector('.form_progress_value').style.width = `${bar_base_value * current_step}%`;
      document.querySelector('.current_page').innerText = current_step;
      document.getElementById('autism_registration').scrollIntoView({ behavior: 'smooth' });
    }
    if (current_step === 1) {
      document.querySelector('.reconnect_pagination_back').style.display = 'none';
      document.body.classList.remove('final_steps');
    }
  });

  nextBtn && nextBtn.addEventListener("click", function (e) {
    if (!validateVisibleRequiredInputs()) {
      return;
    }
    if (current_step < total_steps) {
      current_step += 1;
      document.querySelectorAll('.reconnect_steps_block').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelector(`.reconnect_steps_block[steps_block="${current_step}"]`).style.display = 'block';
      document.body.classList.add('next_steps');
      document.querySelector('.form_progress_value').style.width = `${bar_base_value * current_step}%`;
      document.querySelector('.current_page').innerText = current_step;
      document.getElementById('autism_registration').scrollIntoView({ behavior: 'smooth' });
    }
    if (current_step === total_steps || current_step === 2) {
      document.body.classList.add('final_steps');
      document.querySelector('.reconnect_pagination_back').style.display = 'flex';
    } else {
      document.body.classList.remove('final_steps');
    }
  });

  // Show/hide form based on #proceed-registration
  function updateReconnectForm(radio) {
    const reconnectContainer = radio.closest('.reconnect_step_inside');
    if (reconnectContainer) {
      if (radio.value === 'Yes' && radio.checked) {
        reconnectContainer.classList.add('show_form');
        document.body.classList.remove('final_steps');
      } else if (radio.value === 'No' && radio.checked) {
        reconnectContainer.classList.remove('show_form');
        document.body.classList.add('final_steps');
      }
    }
  }

  document.querySelectorAll('#proceed-registration').forEach(function (radio) {
    radio.addEventListener('change', function (event) {
      updateReconnectForm(event.target);
    });
    updateReconnectForm(radio);
  });

  document.querySelectorAll('.reconnect_pagination_next, #proceed-registration, .reconnect_pagination_back').forEach(function (el) {
    el.addEventListener('click', function () {
      const selectedRadio = document.querySelector('#proceed-registration:checked');
      if (selectedRadio && selectedRadio.value === 'Yes') {
        if (current_step !== total_steps) {
          document.body.classList.remove('final_steps');
        }
      }
    });
  });

  if (current_step !== 4) {
    setTimeout(() => {
      document.body.classList.remove('final_steps');
    }, 500);
  }

  // Form validation
  function validateVisibleRequiredInputs() {
    let isValid = true;
    let firstInvalidField = null;
    const processedGroups = new Set();

    const visibleStep = document.querySelector('.reconnect_steps_block:not([style*="display: none"])');
    if (!visibleStep) return true;

    visibleStep.querySelectorAll('[required]').forEach(function (input) {
      const fieldValues = input.closest('.field_values');
      const inputType = input.type;
      const inputName = input.name;

      if (!fieldValues) return;

      const isGroup = inputType === 'radio' || inputType === 'checkbox';
      const groupKey = isGroup ? `group__${inputName}` : null;
      if (isGroup && processedGroups.has(groupKey)) return;
      if (isGroup) processedGroups.add(groupKey);

      const oldError = fieldValues.querySelector('.error_message');
      if (oldError) oldError.remove();

      let isFieldValid = true;

      if (isGroup) {
        const groupInputs = visibleStep.querySelectorAll(`input[name="${inputName}"]`);
        const anyChecked = Array.from(groupInputs).some(input => input.checked);
        if (!anyChecked) isFieldValid = false;
      } else {
        if (input.offsetParent === null || !input.value.trim()) {
          isFieldValid = false;
        }
      }

      if (!isFieldValid) {
        isValid = false;
        const error = document.createElement('div');
        error.className = 'error_message';
        error.style.color = 'red';
        error.style.marginTop = '6px';
        error.innerText = 'This field is required.';
        fieldValues.appendChild(error);

        if (!firstInvalidField) {
          firstInvalidField = fieldValues;
        }
      }
    });

    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return isValid;
  }

  document.querySelectorAll('[required]').forEach(function (input) {
    const inputType = input.type;

    const removeError = function () {
      const fieldValues = input.closest('.field_values');
      const error = fieldValues?.querySelector('.error_message');
      if (error) error.remove();
    };

    if (inputType === 'radio' || inputType === 'checkbox') {
      input.addEventListener('change', removeError);
    } else {
      input.addEventListener('input', removeError);
    }
  });

  // Disable submit button until form is valid
  document.body.addEventListener('click', function (e) {
    const submitBtn = document.querySelector('.reconnect_form_submit');
    if (!submitBtn) return;

    const currentStepBlock = document.querySelector('.reconnect_steps_block:not([style*="display: none"])');
    const currentStep = parseInt(currentStepBlock?.getAttribute('steps_block'));
    const selectedProceedRadioNo = document.querySelector('#proceed-registration[value="No"]:checked');
    const isStep2AndNoSelected = currentStep === 2 && selectedProceedRadioNo;
    const isStep4AndValid = currentStep === 4 && validateVisibleRequiredInputs();
    const isFormAllowedToSubmit = isStep2AndNoSelected || isStep4AndValid;

    submitBtn.classList.toggle('disabled', !isFormAllowedToSubmit);

    if (e.target === submitBtn && !isFormAllowedToSubmit) {
      e.preventDefault();
    }
  });

  // Form functionality
  const form = document.querySelector('#autism_registration');
  const container = document.querySelector('#child-profile-list');
  const fetch_url = "https://ausimreconnect-af7f949dba1c.herokuapp.com"; //Do not change it
  if (!form || !container) return;

  // Fetch profiles from API
  async function fetchProfiles() {
    document.getElementById('fullPageLoader').style.display = 'block';
    try {
      const response = await fetch(`${fetch_url}/api/get-profiles`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId })
      });
      const result = await response.json();
      if (result.success) {
        return result.data || [];
      } else {
        console.error('Error fetching profiles:', result.error || result.errors);
        alert('Failed to load profiles: ' + JSON.stringify(result.error || result.errors));
        return [];
      }
    } catch (error) {
      console.error('Request failed:', error);
      alert('Request failed.');
      return [];
    } finally {
      document.getElementById('fullPageLoader').style.display = 'none';
    }
  }

  // Show/hide form based on children
  async function updateFormVisibilityBasedOnChildren() {
    const children = await fetchProfiles();
    const addChildBtn = document.querySelector('.add-new-child');
    const profile_main_wrapper = document.querySelector('.profile_main_wrapper');

    if (children.length === 0) {
      form.style.display = 'block';
      addChildBtn.style.display = 'none';
      profile_main_wrapper.style.display = 'none';
    } else {
      form.style.display = 'none';
      addChildBtn.style.display = 'block';
      profile_main_wrapper.style.display = 'block';
    }
  }

  // Render child cards
  async function renderChildren() {
    const children = await fetchProfiles();
    container.innerHTML = '';

    children.forEach((child, index) => {
      const profile = document.createElement('div');
      profile.className = 'child-card';
      profile.innerHTML = `
        <label class="profile-card ${index === 0 ? 'selected' : ''}">
          <input type="radio" name="selected_child_" value="${index}" ${index === 0 ? 'checked' : ''}>
          <div class="child-info">
            <strong>${child.autistic_child_legal_name}</strong><br>
            <small>Autism Spectrum: ${Array.isArray(child.autistic_spectrum) ? child.autistic_spectrum.join(', ') : child.autistic_spectrum || 'N/A'}</small><br>
            <small>Emergency Contact: ${child.contact_1_legal_name || 'N/A'}</small>
          </div>
        </label>
        <button class="edit-child" data-index="${index}" type="button">
          <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 23.3383V6.25057C7.32062e-05 5.27954 0.386123 4.34829 1.07275 3.66166C1.75943 2.97505 2.6906 2.58891 3.66166 2.58891H12.2055L12.3301 2.59547C12.9456 2.65785 13.426 3.17755 13.4261 3.80946C13.4261 4.44151 12.9457 4.96167 12.3301 5.02406L12.2055 5.03002H3.66166C3.33802 5.03002 3.02758 5.15879 2.79869 5.3876C2.56986 5.61644 2.44118 5.92696 2.44111 6.25057V23.3383C2.44111 23.662 2.56979 23.973 2.79869 24.2019C3.02758 24.4307 3.33803 24.5589 3.66166 24.5589H20.7494C21.0731 24.5589 21.3835 24.4307 21.6124 24.2019C21.8413 23.973 21.97 23.662 21.97 23.3383V14.7945C21.9701 14.1205 22.5165 13.5739 23.1905 13.5739C23.8645 13.5739 24.4109 14.1205 24.4111 14.7945V23.3383C24.4111 24.3095 24.025 25.2411 23.3383 25.9278C22.6517 26.6144 21.7205 27 20.7494 27H3.66166C2.6906 27 1.75943 26.6144 1.07275 25.9278C0.386058 25.2411 0 24.3095 0 23.3383ZM24.5589 3.80946C24.5588 3.44666 24.4149 3.09879 24.1584 2.8422C23.9017 2.58553 23.5535 2.44111 23.1905 2.44111C22.873 2.44111 22.5669 2.55155 22.3234 2.75102L22.2227 2.8422L10.8664 14.1979L10.221 16.779L12.8015 16.1336L24.1584 4.77733L24.249 4.6772C24.4486 4.43363 24.5589 4.12715 24.5589 3.80946ZM27 3.80946C27 4.7567 26.6476 5.66793 26.0149 6.36679L25.8843 6.50386L14.2891 18.0991C14.1327 18.2554 13.9368 18.3661 13.7223 18.4198L8.84008 19.6403C8.42422 19.7443 7.98407 19.6227 7.68091 19.3197C7.37779 19.0166 7.25577 18.5764 7.35968 18.1605L8.58024 13.2783L8.60288 13.1984C8.66221 13.015 8.76461 12.8478 8.90147 12.7109L20.4967 1.11566L20.6338 0.985741C21.3327 0.352981 22.2433 -6.7877e-09 23.1905 0C24.2009 1.06457e-08 25.1699 0.401284 25.8843 1.11566C26.5987 1.83006 26.9999 2.79916 27 3.80946Z" fill="#1E1E1E"/>
          </svg>
        </button>
        <button class="delete-child" data-index="${index}" type="button">
          <svg width="27" height="27" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.61 122.88">
            <title>trash</title>
            <path d="M39.27,58.64a4.74,4.74,0,1,1,9.47,0V93.72a4.74,4.74,0,1,1-9.47,0V58.64Zm63.6-19.86L98,103a22.29,22.29,0,0,1-6.33,14.1,19.41,19.41,0,0,1-13.88,5.78h-45a19.4,19.4,0,0,1-13.86-5.78l0,0A22.31,22.31,0,0,1,12.59,103L7.74,38.78H0V25c0-3.32,1.63-4.58,4.84-4.58H27.58V10.79A10.82,10.82,0,0,1,38.37,0H72.24A10.82,10.82,0,0,1,83,10.79v9.62h23.35a6.19,6.19,0,0,1,1,.06A3.86,3.86,0,0,1,110.59,24c0,.20,0,.38,0,.57V38.78Zm-9.5.17H17.24L22,102.3a12.82,12.82,0,0,0,3.57,8.1l0,0a10,10,0,0,0,7.19,3h45a10.06,10.06,0,0,0,7.19-3,12.8,12.8,0,0,0,3.59-8.1L93.37,39ZM71,20.41V12.05H39.64v8.36ZM61.87,58.64a4.74,4.74,0,1,1,9.47,0V93.72a4.74,4.74,0,1,1-9.47,0V58.64Z"/>
          </svg>
        </button>
      `;
      container.appendChild(profile);
    });
  }

  // Load a child into the form for editing
  async function loadChildIntoForm(index) {
    const children = await fetchProfiles();
    const child = children[index];
    if (!child) return;

    form.setAttribute('data-edit-index', index);
    form.setAttribute('data-original-legal-name', child.autistic_child_legal_name);
    form.style.display = 'block';
    form.closest('.reconnect_step_inside')?.classList.add('show_form');

    Object.entries(child).forEach(([key, value]) => {
      const inputs = form.querySelectorAll(`[name="${key}"]`);
      if (!inputs.length) return;

      setTimeout(() => {
        if (inputs.length > 1) {
          inputs.forEach(input => {
            if (input.type === 'checkbox' && Array.isArray(value)) {
              input.checked = value.includes(input.value);
            } else if (input.type === 'radio') {
              input.checked = input.value === value;
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        } else {
          const field = inputs[0];
          if (field.type === 'checkbox') {
            field.checked = (field.value === value) || value === true || value === "true";
          } else if (field.type === 'radio') {
            field.checked = true;
          } else {
            field.value = value;
          }
          field.dispatchEvent(new Event(field.type === 'checkbox' || field.type === 'radio' ? 'change' : 'input', { bubbles: true }));
        }
      }, 0);
    });

    form.scrollIntoView({ behavior: 'smooth' });
  }

  // Submit handler
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    if (!validateVisibleRequiredInputs()) return;
    const formData = new FormData(form);
    const child = {};

    formData.forEach((value, key) => {
      if (child[key]) {
        if (Array.isArray(child[key])) {
          child[key].push(value);
        } else {
          child[key] = [child[key], value];
        }
      } else {
        child[key] = value;
      }
    });

    const editIndex = form.getAttribute('data-edit-index');
    const originalLegalName = form.getAttribute('data-original-legal-name') || child.autistic_child_legal_name;
    
    document.getElementById('fullPageLoader').style.display = 'block';
    try {
      const response = await fetch(`${fetch_url}/api/edit-or-add-profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId,
          originalLegalName,
          updatedData: child
        })
      });

      const result = await response.json();
      if (result.success) {
        const receiveNewsletter = formData.get('receive_newsletter')?.toLowerCase(); // 'yes' or 'no'
        try {
          await fetch(`${fetch_url}/api/newsletter`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customerId,
              subscribe: receiveNewsletter === 'yes'
            })
          });
        } catch (newsletterError) {
          console.error('Marketing preference update failed:', newsletterError);
        }
        form.removeAttribute('data-edit-index');
        form.removeAttribute('data-original-legal-name');
        form.reset();
        form.style.display = 'none';
        await renderChildren();
        await updateFormVisibilityBasedOnChildren();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // location.reload();
        document.querySelector("#success-popup").classList.add("visible");
        document.body.style.overflow = "hidden";
      } else {
        alert("Error: " + JSON.stringify(result.errors || result));
      }
    } catch (error) {
      console.error('Request failed:', error);
      alert("Request failed.");
    } finally {
      document.getElementById('fullPageLoader').style.display = 'none';
    }
  });

  // Click handlers
  document.addEventListener('click', async function (e) {
    // Edit button
    const editButton = e.target.closest('.edit-child');
    if (editButton) {
      const index = parseInt(editButton.getAttribute('data-index'), 10);
      if (!isNaN(index)) await loadChildIntoForm(index);
    }

    // Delete button
    const deleteBtn = e.target.closest('.delete-child');
    if (deleteBtn) {
      const index = parseInt(deleteBtn.dataset.index);
      const children = await fetchProfiles();
      const child = children[index];
      if (child) {
        childToDeleteIndex = index;
        childToDeleteLegalName = child.autistic_child_legal_name;
        document.querySelector("#delete-popup").classList.add("visible");
        document.body.style.overflow = "hidden";
      }
    }

    // Cancel delete
    const popup = document.querySelector("#delete-popup");
    if (popup && (e.target.id === 'cancel-delete' || e.target.closest("#delete-popup .ms_close_btn") || e.target.closest("#delete-popup .ms_popup_overlay"))) {
      childToDeleteIndex = null;
      childToDeleteLegalName = null;
      popup.classList.remove("visible");
      document.body.style.overflow = "auto";
    }

    // Confirm delete
    if (e.target.id === 'confirm-delete' && childToDeleteIndex !== null && childToDeleteLegalName) {
      document.getElementById('fullPageLoader').style.display = 'block';
      try {
        const response = await fetch(`${fetch_url}/api/delete-profile`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId, legalNameToDelete: childToDeleteLegalName })
        });

        const result = await response.json();
        if (result.success) {
          await renderChildren();
          await updateFormVisibilityBasedOnChildren();
        } else {
          alert("Failed to delete profile: " + JSON.stringify(result.error || result.errors));
        }
      } catch (error) {
        console.error("Request failed:", error);
        alert("Request failed.");
      } finally {
        childToDeleteIndex = null;
        childToDeleteLegalName = null;
        document.querySelector("#delete-popup").classList.remove("visible");
        document.body.style.overflow = "auto";
        document.getElementById('fullPageLoader').style.display = 'none';
        location.reload();
      }
    }

    // Add new child
    if (e.target.closest('.add-new-child')) {
      form.reset();
      form.removeAttribute('data-edit-index');
      form.removeAttribute('data-original-legal-name');
      form.style.display = 'block';
      form.closest('.reconnect_step_inside')?.classList.add('show_form');
      document.body.classList.remove('final_steps');
      form.scrollIntoView({ behavior: 'smooth' });
    }
  });

  // Initial render
  (async () => {
    await renderChildren();
    await updateFormVisibilityBasedOnChildren();
  })();

  let childToDeleteIndex = null;
  let childToDeleteLegalName = null;
}